/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { STORAGE_KEYS } from '../../constants';
import { UserProfileActions, UserProfileStates } from './user-profile.models';

const initialState: UserProfileStates = {
  accountProviders: [],
  accountStatus: 'unknown',
  defaultProvider: undefined,
  nickName: '',
};

export const useUserProfileStore = create<UserProfileActions & UserProfileStates>()(
  persist(
    (set) => ({
      ...initialState,
      resetProfile: () => {
        set(initialState);
      },
      updateProfile: (partial) => {
        set(partial);
      },
    }),
    {
      name: STORAGE_KEYS['USER_PROFILE_STORE'],
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        accountStatus: state.accountStatus,
        nickName: state.nickName,
      }),
    },
  ),
);
